import React, { useContext, useEffect, useState } from "react";
import embLabels from "../../config/emb-labels-en.json";
import Tooltip from "../../utils/Tooltip";
import { AssetBlockContext } from "../CustomHooks/ContextApi";

const LoadAsset = ({loadData = {}}) => {
  
  const {
    configData,
    handleLoadChange,
    updateLoadConfig,
    removeLoad,
    calculateMaxAvailableLoadPower,
    projectKind,
    CBLoadList,
    selectedValues,
    handleLoadCBAssetRequired,
    handleLoadPmAssetRequired,
    updateLoadCbPm,
    isLoadNameUnique
  } = loadData;

  const loadChangeHandler = e => {
       handleLoadChange(e);
  };
  const isPmCheckBoxEnabled = () => ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)||((projectKind?.isMgaasAnsiIsland || projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland)&&CBLoadList[selectedValues.selectedLoad]?.uiData.isRemoteLoad));
  const isPmDisabled = () =>  {
    if(((projectKind?.isMgaasAnsiIsland || projectKind?.isDaasAnsiIsland | projectKind?.isDaasEtoIsland)&&CBLoadList[selectedValues.selectedLoad]?.uiData.isRemoteLoad)){
      return CBLoadList[selectedValues.selectedLoad]?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired"
    }
  }

  const loadPower =  calculateMaxAvailableLoadPower?.();
 if(loadPower){
  var  [powerIsBetween, nominalPowerMin, nominalPowerMax] = loadPower;
 }
  

  return (
    <>
    <div name="CB" className="col-md-12 p-0">
      {/* <div className="col-md-12 pt-2 se-white-background">
        <div className="row">
          <div className="col-md-8 ">
            <se-icon
              color="primary"
              className="se-icon icon_button se-life-green"
            >
              segment_building_small
            </se-icon>
            <span className="ml-2 bold align-top line-height-30px">Load</span>
          </div>
          <div className="col-md-4 ">
            <span className="float-right">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={removeLoad}
              >
                Remove
              </button>
            </span>
          </div>
        </div>
      </div> */}

      <div className="col-md-12 mt-2  pt-1 se-white-background align-middle se-border">
        <div className="row">
          <label className=" col-md-5 bold mt-1 pt-2 se-font-14px">
            Asset Settings
          </label>
          <div className="col-md-7 mt-1 mb-1 text-right">
            <button
              type="button"
              className="btn btn-secondary btn-sm se-btn-secondary"
              // onClick={updateLoadConfig}
              onClick={updateLoadCbPm}
            >
              <se-icon size="nano">action_save</se-icon>
              <span>&nbsp;</span>Save Settings
            </button>
          </div>
        </div>
      </div>
      <div className="col-md-12 pb-2 pt-2 se-grey-background">
        <div className="form-group mb-1">
          {isPmCheckBoxEnabled() && (
            <>
                {!projectKind?.isMgaasIecIsland && !projectKind?.isMGaaSETOIsland &&<div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input asCompatible"
                    name="pmRequired"
                    id="pmRequiredValidation"
                    onChange={()=>handleLoadPmAssetRequired(selectedValues.selectedLoad)}
                    value={ 
                      CBLoadList[selectedValues.selectedLoad]?.uiData
                        .pmRequired
                    }
                    checked={
                      CBLoadList[selectedValues.selectedLoad]?.uiData
                        .pmRequired
                    }
                    disabled={isPmDisabled()}
                  />
                  <label
                    className="custom-control-label line-height-25"
                    htmlFor="pmRequiredValidation"
                  >
                    {"Enable resource energy monitoring"}
                  </label>
                  <Tooltip
                    position="right"
                    iconColor="secondary"
                    information=" Once selected, a power meter will be added to this branch to allow accurate metering, or specific sub metering function"
                  />
                </div>}
                {(projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)&&<>
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input asCompatible"
                    name="cBRequired"
                    id="cBRequiredValidation"
                    onChange={(e)=>handleLoadCBAssetRequired(selectedValues.selectedLoad, e) }
                    value={
                      CBLoadList[selectedValues.selectedLoad]?.uiData
                        .cbRequired
                    }
                    checked={
                      CBLoadList[selectedValues.selectedLoad]?.uiData
                        .cbRequired
                    }
                  />
                  <label
                    className="custom-control-label line-height-25"
                    htmlFor="cBRequiredValidation"
                  >
                    {"Enable breaker control"}
                  </label>
                  <Tooltip
                    position="right"
                    iconColor="secondary"
                    information=" Select this option to allow manual branch operation via EMO-M HMI."
                  />
                </div>
                </>}
            </>
          )}
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput1"
            placeholder="Name"
            name="name"
            value={configData?.configData?.name}
            onChange={loadChangeHandler}
          />
          <div
            className="invalid-feedback-custom"
            style={!configData?.configData?.name ? {} : { display: "none" }}
          >
            {embLabels.nameRequired}
          </div>
          <div
            className="invalid-feedback-custom"
            style={isLoadNameUnique ? {} : { display: "none" }}
          >
            {"Name already used for another load."}
          </div>
          <div
            className="invalid-feedback-custom"
            style={configData?.configData?.name !==""  && !/^[a-zA-Z0-9-_ ]+$/.test(configData?.configData?.name )? {} : { display: "none" }}
          >
            {embLabels.notallowedAlphanumericValues}
          </div>
          
        </div>
        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">Description</label>
          <input
            type="text"
            autoComplete="none"
            className="form-control form-control-sm"
            id="exampleFormControlInput1"
            placeholder="Description"
            name="description"
            value={configData?.configData?.description}
            onChange={loadChangeHandler}
          />
        </div>
        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">
            Maximum load power (kW) <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput1"
            placeholder="Maximum load power"
            maxLength={8}
            name="maximum_available_power"
            value={configData?.configData?.maximum_available_power}
            onChange={loadChangeHandler}
          />
          <div
            className="invalid-feedback-custom"
            style={
              configData?.configData?.maximum_available_power === ""
                ? {}
                : { display: "none" }
            }
          >
            Maximum load power (kW) is required.
          </div>
          {configData?.configData?.maximum_available_power === "0" ||configData?.configData?.maximum_available_power === 0  ? (
            <div className="invalid-feedback-custom-warning ">
              The load power is set to 0
              {/* Maximum load power should be in range( {nominalPowerMin} -
              {nominalPowerMax} kW). */}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default LoadAsset;
